import { useAuth } from 'lib/auth';
import {
  OrderAPISortBy,
  useLastCompletedOrder,
  useUserOrders,
} from 'lib/order';
import { APISortDirection } from 'lib/utils';

const useHomePage = () => {
  const { session, loading: isAuthLoading } = useAuth();
  const user = session?.user;
  const userId: string | null = isAuthLoading
    ? null
    : user?.userId ?? null;

  const { total, isLoading: isOrdersLoading } = useUserOrders(
    userId,
    {
      sortDir: APISortDirection.DESCENDING,
      sortField: OrderAPISortBy.CREATED_AT,
      perPage: '1',
      page: '1',
    },
  );

  const {
    order: lastCompletedOrder,
    isLoading: isLastCompletedOrderLoading,
  } = useLastCompletedOrder(userId);

  return {
    isAuthLoading,
    user,
    totalOrders: total,
    isOrdersLoading,
    lastCompletedOrder,
    isLastCompletedOrderLoading,
  };
};

export default useHomePage;
